import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserHappyPayBankAccountDialogComponent } from '@features/user/components/user-happy-pay-bank-account-dialog/user-happy-pay-bank-account-dialog.component';
import { HappyPayBankAccount } from '@features/user/interfaces/happy-pay.interface';
import { HappyPayBankAccountService } from '@features/user/services/happy-pay-bank-account.service';
import {
  faEdit,
  faSquarePlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-user-happy-pay-bank-account',
  templateUrl: './user-happy-pay-bank-account.component.html',
  styleUrls: ['./user-happy-pay-bank-account.component.css'],
})
export class UserHappyPayBankAccountComponent implements OnInit, OnDestroy {
  faSquarePlus = faSquarePlus;
  faEdit = faEdit;
  faTrash = faTrash;

  //subject
  private readonly destroy$ = new Subject<void>();

  bankAccounts: HappyPayBankAccount[] = [];
  constructor(
    private hpBankAccService: HappyPayBankAccountService,
    private dialogService: DialogService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData() {
    this.hpBankAccService
      .getHappyPayBankAccounts()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => (this.bankAccounts = data));
  }

  delete(bankAccountId: number) {
    if (confirm('Apakah anda yakin ingint menghapus akun bank ini?')) {
      this.hpBankAccService
        .deleteHappyPayBankAccount(bankAccountId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.bankAccounts = this.bankAccounts.filter(
            (ba) => ba.id !== bankAccountId
          );
        });
    }
  }

  showBankAccountDialog(account: any = {}) {
    let style;
    if (this.layoutService.isMobile$.value) {
      style = {
        'max-height': '100%',
        width: '100vh',
        height: '100vh',
        overflow: 'hidden',
      };
    } else {
      style = {
        'border-radius': '1rem',
        overflow: 'hidden',
      };
    }
    const ref = this.dialogService.open(
      UserHappyPayBankAccountDialogComponent,
      {
        dismissableMask: true,
        data: {
          bankAccount: account,
        },
        closable: true,
        showHeader: false,
        width: '500px',
        contentStyle: {
          padding: '0',
        },
        style: style,
      }
    );

    ref.onClose.subscribe((isUpdated: boolean) => {
      if (isUpdated) {
        this.loadData();
      }
    });
  }
}
